import { ISOTime } from "./ISOTime";

export const timeHHMMvalidator = (value: string) => {
  return !!ISOTime.create(value).value;
};

export const phoneNumber = (value: string) =>
  /^\+(?:[0-9] ?){6,14}[0-9]$/.test(value);
